import React from "react";
import Navbar from "../Components/NavMenu";
import "../App.css";
import "../Styles/Dashboard.css";
import Menus from "../Components/Menus";

function Dashboard() {
  return (
    <div className="App content-wrapper dashboard-app">
      <Navbar />
      <main className="dashboard-shell">
        <Menus />
      </main>
    </div>
  );
}

export default Dashboard;
